import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { JobFlowStack } from '@data-terminal/shared-models/job-flow';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'data-terminal-job-flow-stack-card',
    imports: [MatCardModule, TranslateModule, MatIcon],
    templateUrl: './job-flow-stack-card.component.html',
    styleUrl: './job-flow-stack-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobFlowStackCardComponent {
    public readonly stack = input.required<JobFlowStack>();

    public readonly isInputStackCompleted = input(false);

    public readonly goodPercentage = computed(() => {
        const { stackQuantityGood, stackQuantityWaste } = this.stack();
        const total = stackQuantityGood + stackQuantityWaste;
        return total > 0 ? (stackQuantityGood * 100) / total : 0;
    });

    public readonly wastePercentage = computed(() => {
        const { stackQuantityGood, stackQuantityWaste } = this.stack();
        return stackQuantityGood + stackQuantityWaste > 0 ? 100 - this.goodPercentage() : 0;
    });
}
